import { icons } from "assets/AssetHelper";

export const detailsData = ({ data, t }) => [
  {
    head: t("common.details"),
    icon: icons?.detailsIcon,
    details: [
      {
        label: t("driver_complaint_reasons.reason_en"),
        name: data?.localized_data?.en?.name,
      },
      {
        label: t("driver_complaint_reasons.reason_ar"),
        name: data?.localized_data?.ar?.name,
      },
    ],
  },
  {
    head: t("details.dates"),
    icon: icons.detailsIcon,
    details: [
      {
        label: t("details.created_at"),
        name: data?.created_at,
      },
      {
        label: t("details.updated_at"),
        name: data?.updated_at,
      },
    ],
  },
];
